import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-lg-row" }
const _hoisted_2 = { class: "card card-flush d-flex flex-shrink-1" }
const _hoisted_3 = {
  class: "card-header d-flex pt-7",
  id: "kt_chat_contacts_header"
}
const _hoisted_4 = {
  class: "flex-fill position-relative ms-1",
  autocomplete: "off"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 ms-5 translate-middle-y" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "el-dropdown-link" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-sm btn-light" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-filter fs-2x" })
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("همه")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("در انتظار")
const _hoisted_9 = {
  class: "card-body pt-5",
  id: "kt_chat_contacts_body",
  "element-loading-text": "درحال بارگزاری ..."
}
const _hoisted_10 = {
  class: "scroll-y me-n5 pe-5",
  style: {"max-height":"90vh !important"},
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_header, #kt_toolbar, #kt_footer, #kt_chat_contacts_header",
  "data-kt-scroll-wrappers": "#kt_content, #kt_chat_contacts_body",
  "data-kt-scroll-offset": "0px"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_13 = { class: "symbol symbol-40px symbol-circle" }
const _hoisted_14 = { class: "fs-7 fw-bolder text-gray-700 text-hover-primary mb-2" }
const _hoisted_15 = {
  key: 0,
  class: "symbol symbol-20px me-1"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  class: "fw-lighter text-gray-400 fs-7",
  style: {"direction":"ltr"}
}
const _hoisted_18 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_19 = { class: "symbol symbol-40px symbol-circle" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "ms-5" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "fs-6 fw-bolder text-gray-900 text-hover-primary mb-2" }, "ناشناس")
], -1)
const _hoisted_21 = { class: "d-flex align-items-center ms-2" }
const _hoisted_22 = { class: "fs-8 text-gray-600" }
const _hoisted_23 = {
  class: "card",
  id: "kt_chat_messenger"
}
const _hoisted_24 = {
  class: "card-header",
  id: "kt_chat_messenger_header"
}
const _hoisted_25 = { class: "card-title d-flex justify-content-between align-items-center" }
const _hoisted_26 = { class: "d-flex flex-fill flex-column justify-content-center me-3" }
const _hoisted_27 = { class: "fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-2 lh-1" }
const _hoisted_28 = { class: "text-muted fs-7 fw-lighter mb-1" }
const _hoisted_29 = { class: "card-toolbar" }
const _hoisted_30 = { class: "me-n3" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-sm btn-light-danger" }, " بستن گفتگو ", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left fs-2" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  class: "card-body pb-0",
  id: "kt_chat_messenger_body"
}
const _hoisted_35 = {
  class: "scroll-y me-n5 pe-5 d-flex flex-column-reverse justify-content-start",
  id: "kt_chat_scroll_admin",
  ref: "messagesRef",
  "data-kt-element": "messages",
  "data-kt-scroll": "true",
  "data-kt-scroll-dependencies": "#kt_header, #kt_toolbar, #kt_footer, #kt_chat_messenger_header, #kt_chat_messenger_footer",
  "data-kt-scroll-wrappers": "#kt_content, #kt_chat_messenger_body",
  "data-kt-scroll-offset": "-2px",
  style: {"height":"50vh !important"}
}
const _hoisted_36 = {
  class: "card-footer pt-4",
  id: "kt_chat_messenger_footer"
}
const _hoisted_37 = ["placeholder"]
const _hoisted_38 = { class: "d-flex flex-stack" }
const _hoisted_39 = { class: "d-flex align-items-center me-2" }
const _hoisted_40 = ["title"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-paperclip fs-3" }, null, -1)
const _hoisted_42 = { class: "indicator-label" }
const _hoisted_43 = { class: "indicator-progress" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_UserAvatar = _resolveComponent("UserAvatar")!
  const _component_Date = _resolveComponent("Date")!
  const _component_Status = _resolveComponent("Status")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_MessageIn = _resolveComponent("MessageIn")!
  const _component_MessageOut = _resolveComponent("MessageOut")!
  const _component_Emoji = _resolveComponent("Emoji")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle(`${
        _ctx.mobileUiChat === true && _ctx.newMessage.activeBox === false
          ? 'display:none'
          : ''
      }`),
      class: "flex-column flex-lg-row-auto w-100 w-lg-300px w-xl-400px mb-10 mb-lg-0"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-solid px-15",
              name: "search",
              placeholder: "جستجو ...",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter.search) = $event))
            }, null, 512), [
              [_vModelText, _ctx.filter.search]
            ])
          ]),
          _createVNode(_component_el_dropdown, null, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown_item, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.status = false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_dropdown_item, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter.status = true))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conversationsList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                onClick: ($event: any) => {
                  _ctx.newMessage.fileInputKey++;
                  _ctx.newMessage.activeBox = false;
                  _ctx.setLastMessageIdNull();
                  _ctx.fetchConversationBody(item.conversation_id);
                },
                class: "d-flex flex-stack py-1 cursor-pointer bg-hover-light-dark bg-active-lighten border-bottom border-bottom-dotted border-gray-300 border-hover-primary"
              }, [
                (item.user)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        (item.user?.avatar)
                          ? (_openBlock(), _createBlock(_component_UserAvatar, {
                              key: 0,
                              avatar: item.user?.avatar,
                              size: "40px",
                              id: item.user?.id
                            }, null, 8, ["avatar", "id"]))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: _normalizeClass([`bg-light-primary text-primary`, "symbol-label fs-6 fw-bolder me-5"])
                            }, "ن"))
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("a", _hoisted_14, [
                          (item.user?.country)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                _createElementVNode("img", {
                                  class: "rounded-1",
                                  src: `https://flagcdn.com/w40/${item.user?.country.alpha2_code.toLowerCase()}.webp`,
                                  alt: "Inboxino"
                                }, null, 8, _hoisted_16)
                              ]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(item.user?.first_name + " " + item.user?.last_name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_17, _toDisplayString(item.user?.mobile), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("span", {
                          class: _normalizeClass([`bg-light-primary text-primary`, "symbol-label fs-6 fw-bolder"])
                        }, "ن")
                      ]),
                      _hoisted_20
                    ])),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_Date, {
                      date: item.last_message_date,
                      type: "human"
                    }, null, 8, ["date"])
                  ]),
                  _createVNode(_component_Status, {
                    "only-icon": "",
                    status: item.status
                  }, null, 8, ["status"])
                ])
              ], 8, _hoisted_11))
            }), 128))
          ])
        ])), [
          [_directive_loading, _ctx.loadingConversations]
        ])
      ])
    ], 4),
    _createElementVNode("div", {
      style: _normalizeStyle(`${
        _ctx.mobileUiChat === true && _ctx.newMessage.activeBox === true
          ? 'display:none;'
          : ''
      }`),
      class: "flex-lg-row-fluid ms-lg-7 ms-xl-10"
    }, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.activeConversation?.user?.first_name) + " " + _toDisplayString(_ctx.activeConversation?.user?.last_name), 1),
              _createElementVNode("span", _hoisted_28, [
                (
                    _ctx.activeConversation &&
                    _ctx.activeConversation.user &&
                    _ctx.activeConversation.user.last_seen
                  )
                  ? (_openBlock(), _createBlock(_component_Date, {
                      key: 0,
                      type: "date",
                      date: _ctx.activeConversation.user.last_seen
                    }, null, 8, ["date"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_el_popconfirm, {
                "confirm-button-text": "بله",
                "cancel-button-text": "خیر",
                "icon-color": "#626AEF",
                title: "آیا می‌خواهید این گفتگو را ببندید ؟",
                onConfirm: _cache[3] || (_cache[3] = ($event: any) => (
                  _ctx.closeConversation(_ctx.activeConversation?.conversation_id)
                ))
              }, {
                reference: _withCtx(() => [
                  _hoisted_31
                ]),
                _: 1
              }),
              (_ctx.mobileUiChat === true && _ctx.newMessage.activeBox === false)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-sm btn-icon btn-hover-scale bg-hover-primary btn-active-light-primary ms-2",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.newMessage.activeBox = true))
                  }, _hoisted_33))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conversationBody, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                (item.type !== 'sender')
                  ? (_openBlock(), _createBlock(_component_MessageIn, {
                      ref_for: true,
                      ref: "messagesInRef",
                      key: index,
                      name: 
                  item?.user?.first_name +
                  ' ' +
                  item?.user?.last_name +
                  ` (${_ctx.translate('operator')})`
                ,
                      image: item?.user && item?.user.avatar,
                      time: item.sent_at,
                      text: item.message,
                      file: item.file,
                      item: item
                    }, null, 8, ["name", "image", "time", "text", "file", "item"]))
                  : _createCommentVNode("", true),
                (item.type === 'sender')
                  ? (_openBlock(), _createBlock(_component_MessageOut, {
                      ref_for: true,
                      ref: "messagesOutRef",
                      key: index,
                      name: 
                  item?.user?.first_name +
                  ' ' +
                  item?.user?.last_name +
                  ` (${_ctx.translate('user')})`
                ,
                      image: item?.user && item?.user.avatar,
                      time: item.sent_at,
                      text: item.message,
                      file: item.file,
                      item: item
                    }, null, 8, ["name", "image", "time", "text", "file", "item"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ], 512)
        ])), [
          [_directive_loading, _ctx.loadingConversationBody]
        ]),
        _createElementVNode("div", _hoisted_36, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newMessage.text) = $event)),
            class: "form-control form-control-solid mb-3",
            "data-kt-element": "input",
            placeholder: _ctx.translate('Enter your message')
          }, null, 8, _hoisted_37), [
            [_vModelText, _ctx.newMessage.text]
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_component_Emoji, { onSelectedEmoji: _ctx.addEmoji }, null, 8, ["onSelectedEmoji"]),
              _createElementVNode("label", {
                class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px",
                "data-kt-image-input-action": "change",
                "data-bs-toggle": "tooltip",
                title: _ctx.translate('send file')
              }, [
                _hoisted_41,
                (_openBlock(), _createElementBlock("input", {
                  type: "file",
                  ref: "file",
                  class: "d-none",
                  key: _ctx.newMessage.fileInputKey
                }))
              ], 8, _hoisted_40)
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addNewMessage && _ctx.addNewMessage(...args))),
              ref: "submitButton",
              id: "kt_send_activation_code_submit",
              class: "btn btn-primary"
            }, [
              _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.translate("send")), 1),
              _createElementVNode("span", _hoisted_43, [
                _createTextVNode(_toDisplayString(_ctx.translate("please wait")) + " ", 1),
                _hoisted_44
              ])
            ], 512)
          ])
        ])
      ])
    ], 4)
  ]))
}